module.exports = __webpack_public_path__ + "img/open_book.cbf78325.svg";